module.exports = __webpack_public_path__ + "img/FR10907.8ded1065.png";